module.exports = __webpack_public_path__ + "static/media/line_chart.4aa84470.svg";